import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "manager-requests__detail" }
const _hoisted_2 = { class: "manager-requests__detail-header" }
const _hoisted_3 = { class: "manager-requests__detail-status" }
const _hoisted_4 = { class: "manager-requests__detail-tabs-container" }
const _hoisted_5 = { class: "manager-requests__detail-info-list" }
const _hoisted_6 = { class: "manager-requests__detail-main-info" }
const _hoisted_7 = { class: "manager-requests__detail-basic-info" }
const _hoisted_8 = { class: "manager-requests__detail-info-item" }
const _hoisted_9 = { class: "manager-requests__detail-info-item" }
const _hoisted_10 = { class: "manager-requests__detail-info-item" }
const _hoisted_11 = { class: "manager-requests__detail-info-item" }
const _hoisted_12 = { class: "manager-requests__detail-text" }
const _hoisted_13 = { class: "manager-requests__detail-files-upload" }
const _hoisted_14 = {
  key: 0,
  class: "manager-requests__detail-files-actions"
}
const _hoisted_15 = {
  key: 0,
  class: "manager-requests__detail-saved-files"
}
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "manager-requests__detail-file-size" }
const _hoisted_18 = {
  key: 0,
  class: "manager-requests__detail-history"
}
const _hoisted_19 = { class: "manager-requests__detail-history-status" }
const _hoisted_20 = { class: "manager-requests__detail-history-date" }
const _hoisted_21 = {
  key: 1,
  class: "manager-requests__detail-no-history"
}

import { ref, watch, computed } from 'vue';
import Button from 'primevue/button';
import Select from 'primevue/select';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import FileUpload from 'primevue/fileupload';
import type { Request, RequestStatus } from '../types';


export default /*@__PURE__*/_defineComponent({
  __name: 'RequestDetail',
  props: {
    request: {},
    loading: { type: Boolean }
  },
  emits: ["close", "status-updated", "files-uploaded", "reply"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const activeTab = ref('info');

const statusOptions = [
  { label: 'Новая', value: 'Новая' },
  { label: 'В работе', value: 'В работе' },
  { label: 'Требуется информация', value: 'Требуется информация' },
  { label: 'Исполнена', value: 'Исполнена' },
  { label: 'Отклонена', value: 'Отклонена' },
];

const selectedStatus = ref<RequestStatus>(props.request.status);
const attachedFiles = ref<File[]>([]);
const fileUploadRef = ref();
const fileUploadKey = ref(0);

const hasStatusChanged = computed(() => {
  return selectedStatus.value !== props.request.status;
});

watch(
  () => props.request.status,
  (newStatus) => {
    selectedStatus.value = newStatus;
  },
);

function saveStatus() {
  if (hasStatusChanged.value) {
    emit('status-updated', selectedStatus.value);
  }
}

function onFileSelect(event: any) {
  if (props.loading) return;

  const files = event.files;
  if (files && Array.isArray(files)) {
    const validFiles = files.filter((file: any): file is File => file instanceof File);
    attachedFiles.value.push(...validFiles);
  }
}

function onFileRemove(event: any) {
  if (props.loading) return;

  const removedFile = event.file;
  attachedFiles.value = attachedFiles.value.filter(
    (f) => f.name !== removedFile.name || f.size !== removedFile.size,
  );
}

function saveFiles() {
  if (attachedFiles.value.length > 0 && !props.loading) {
    emit('files-uploaded', [...attachedFiles.value]);
  }
}

function formatDate(isoString: string): string {
  return new Date(isoString).toLocaleString('ru-RU');
}

// Экспортируем метод для очистки извне
__expose({
  clearAttachedFiles: () => {
    attachedFiles.value = [];
    fileUploadKey.value++;
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("label", null, "Статус заявки:", -1)),
        _createVNode(_unref(Select), {
          modelValue: selectedStatus.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedStatus).value = $event)),
          options: statusOptions,
          optionLabel: "label",
          optionValue: "value",
          disabled: __props.loading
        }, null, 8, ["modelValue", "disabled"]),
        (hasStatusChanged.value)
          ? (_openBlock(), _createBlock(_unref(Button), {
              key: 0,
              label: "Сохранить",
              icon: "pi pi-save",
              onClick: saveStatus,
              class: "manager-requests__detail-save-btn",
              disabled: __props.loading
            }, null, 8, ["disabled"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(Tabs), {
        value: activeTab.value,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((activeTab).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TabList), null, {
            default: _withCtx(() => [
              _createVNode(_unref(Tab), { value: "info" }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("Информация о заявке", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_unref(Tab), { value: "files" }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode("Прикрепленные документы", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_unref(Tab), { value: "history" }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("История статусов", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(TabPanels), null, {
            default: _withCtx(() => [
              _createVNode(_unref(TabPanel), { value: "info" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _cache[8] || (_cache[8] = _createElementVNode("strong", null, "ID заявки:", -1)),
                          _createElementVNode("span", null, "#" + _toDisplayString(__props.request.id), 1)
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _cache[9] || (_cache[9] = _createElementVNode("strong", null, "Дата создания:", -1)),
                          _createElementVNode("span", null, _toDisplayString(formatDate(__props.request.createdAt)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _cache[10] || (_cache[10] = _createElementVNode("strong", null, "Компания:", -1)),
                          _createElementVNode("span", null, _toDisplayString(__props.request.companyName || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _cache[11] || (_cache[11] = _createElementVNode("strong", null, "E-mail:", -1)),
                          _createElementVNode("span", null, _toDisplayString(__props.request.email || '—'), 1)
                        ])
                      ]),
                      _createVNode(_unref(Button), {
                        label: "Ответить",
                        icon: "pi pi-reply",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('reply'))),
                        disabled: __props.loading,
                        class: "manager-requests__detail-reply-btn"
                      }, null, 8, ["disabled"])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.request.fields, (field, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "manager-requests__detail-info-item"
                      }, [
                        _createElementVNode("strong", null, _toDisplayString(field.fieldName) + ":", 1),
                        _createElementVNode("p", _hoisted_12, _toDisplayString(field.fieldValue || '—'), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(TabPanel), { value: "files" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_13, [
                    (_openBlock(), _createBlock(_unref(FileUpload), {
                      ref_key: "fileUploadRef",
                      ref: fileUploadRef,
                      name: "replyAttachments[]",
                      multiple: true,
                      accept: ".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx",
                      maxFileSize: 20971520,
                      customUpload: true,
                      auto: false,
                      previewWidth: 0,
                      chooseLabel: "Выбрать файлы",
                      onSelect: onFileSelect,
                      onRemove: onFileRemove,
                      files: attachedFiles.value,
                      "onUpdate:files": _cache[2] || (_cache[2] = ($event: any) => ((attachedFiles).value = $event)),
                      disabled: __props.loading,
                      cancelLabel: "Очистить",
                      showUploadButton: false,
                      key: fileUploadKey.value
                    }, null, 8, ["files", "disabled"])),
                    (attachedFiles.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createVNode(_unref(Button), {
                            label: __props.loading ? 'Загрузка...' : 'Сохранить файлы',
                            icon: __props.loading ? 'pi pi-spin pi-spinner' : 'pi pi-upload',
                            onClick: saveFiles,
                            disabled: __props.loading
                          }, null, 8, ["label", "icon", "disabled"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (__props.request.files && __props.request.files.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("ul", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.request.files, (file, index) => {
                            return (_openBlock(), _createElementBlock("li", { key: index }, [
                              _createElementVNode("a", {
                                href: file.url,
                                target: "_blank"
                              }, _toDisplayString(file.name), 9, _hoisted_16),
                              _createElementVNode("span", _hoisted_17, "(" + _toDisplayString(file.size) + ")", 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_unref(TabPanel), { value: "history" }, {
                default: _withCtx(() => [
                  (__props.request.history && __props.request.history.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.request.history, (entry, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "manager-requests__detail-history-item"
                          }, [
                            _createElementVNode("span", _hoisted_19, _toDisplayString(entry.status), 1),
                            _createElementVNode("span", _hoisted_20, _toDisplayString(formatDate(entry.date)), 1)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_21, " История статусов отсутствует "))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ])
  ]))
}
}

})